import { render } from "./AposContextMenu.vue?vue&type=template&id=51f62dc0"
import script from "./AposContextMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AposContextMenu.vue?vue&type=script&setup=true&lang=js"

import "./AposContextMenu.vue?vue&type=style&index=0&id=51f62dc0&lang=scss"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ui/ui/apos/components/AposContextMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51f62dc0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51f62dc0', __exports__)) {
    api.reload('51f62dc0', __exports__)
  }
  
  module.hot.accept("./AposContextMenu.vue?vue&type=template&id=51f62dc0", () => {
    api.rerender('51f62dc0', render)
  })

}


export default __exports__